<template>
    <div class="content-box">
        <el-card class="box-card">
            <el-form :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item label="DBC文件名 : ">
                    <el-input v-model="formInline.fileName" size="mini" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="所属车型 : ">
                    <el-select v-model="formInline.vehicleType" size="mini" placeholder="请选择">
                        <el-option
                                v-for="item in carOptions"
                                :key="item.vehicleTypeCode"
                                :label="item.vehicleTypeName"
                                :value="item.vehicleTypeCode">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="创建时间">
                    <el-date-picker
                            value-format="yyyy-MM-dd hh:mm:ss"
                            @change="timeChange"
                            size="mini"
                            v-model="formInline.date"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button @click="search" type="primary" size="mini">查询</el-button>
                    <el-button @click="rest" size="mini">重置</el-button>
                </el-form-item>
            </el-form>
            <div style="margin-bottom: 20px">
                <el-button v-show="!loading" size="mini" @click="openDrawer(1)">新增</el-button>
                <el-button v-show="!loading"  size="mini" @click="openDrawer(2)">修改</el-button>
                <el-popconfirm
                        style="padding: 10px"
                        title="确定将选择数据删除？"
                        @confirm="deleteItems"
                >
                    <el-button v-show="!loading"  size="mini" slot="reference">删除</el-button>
                </el-popconfirm>
                <el-button v-show="!loading" size="mini" @click="downLoadDbc">下载</el-button>
                <el-button v-show="loading" type="primary" @click="loadingDbc" size="mini">加载</el-button>
            </div>
            <el-table
                    class="tableListValue"
                    :height="tableHeight"
                    ref="table"
                    :data="tableData"
                    stripe
                    style="width: 100%">
                <el-table-column
                        type="selection"
                        width="55">
                </el-table-column>
                <el-table-column
                        type="index"
                        label="序号"
                        align="center">
                    <template #default="scope">
                        <span v-text="getIndex(scope.$index)"></span>
                    </template>
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        align="center"
                        prop="fileName"
                        label="DBC文件名"
                        width="180">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="vehicleTypeName"
                        align="center"
                        label="所属车型">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="remark"
                        align="center"
                        min-width="80"
                        label="备注">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="createTime"
                        align="center"
                        label="创建时间">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="creator"
                        align="center"
                        label="创建人">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="modifTime"
                        align="center"
                        label="修改时间">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="modifer"
                        align="center"
                        label="修改人">
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                </el-pagination>
            </div>
        </el-card>
        <!--    新增修改弹框-->
        <el-drawer
                :destroy-on-close="true"
                :show-close="false"
                :title="drawerTitle"
                :visible.sync="drawerType"
                direction="rtl"
                size="30%">
            <DBCDialog :drawerForm="drawerForm" :dialogType="dialogType"
                       @drawerClose="drawerClose"></DBCDialog>
        </el-drawer>
    </div>
</template>

<script>
    import DBCDialog from '../configurationManagement/components/dbcDialog'
    import {getDatavehicleTypeList} from "../../common/carModelApi";
    import { getDbcList, delDbcFiles, downloadDbcFile } from "../../common/dbc"
    import {exportFile} from "../../utils/utils";
    export default {
        name: "DBCAdministration",
        components: {
            DBCDialog
        },
        data() {
            return {
                drawerTitle: '',
                tableHeight: 0,
                drawerForm: {},
                drawerType: false,
                deleteType: false,
                dialogType: 0,
                formInline: {},
                tableData: [],
                carOptions: [],
                currentPage: 1,
                pageSize: 100,
                total: null,
                isLoading: null
            }
        },
        created() {
            if (this.$route.name === 'DBCAdministration') {
                console.log('1')
                this.loading = false
            }else{
                console.log('2')
                this.loading = true
            }
        },
        mounted() {
            this.$nextTick(function () {
                this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 85
            })
            this.getDatavehicleTypeList()
            this.getDbcList()
        },
        methods: {
            downLoadDbc() {
                const arr = this.$refs.table.selection;
                if (arr.length === 0) {
                    this.$notify.error({
                        title: '操作错误 !',
                        message: '请选择数据后操作 !'
                    })
                    return
                }
                if (arr.length > 1) {
                    this.$notify.error({
                        title: '操作错误 !',
                        message: '只可选择一条数据后操作 !'
                    })
                    return
                }
                console.log(arr[0].id)
                downloadDbcFile({id:arr[0].id}).then(res=>{
                    console.log(res)
                    if (res.status === 'failure') {
                        this.$notify.error({
                            title: '错误提示',
                            message: res.message
                        })

                    } else {
                        let fileNames = res.headers['content-disposition'] //获取到Content-Disposition;filename
                        let regFileNames = fileNames.match(/=(.*)$/)[1]; //文件名称  截取=后面的文件名称
                        exportFile(res.data, decodeURI(regFileNames,'utf-8'))
                        this.$refs.table.clearSelection();
                        // this.$notify.error({
                        //     title: '错误提示',
                        //     message: '导出数据失败 !'
                        // })
                    }
                }).catch(err=>{
                    console.log(err)
                })
            },
            // 加载DBC
            loadingDbc() {
                const arr = this.$refs.table.selection;
                if (arr.length === 0) {
                    this.$notify.error({
                        title: '操作错误 !',
                        message: '请选择数据后操作 !'
                    })
                    return
                }
                if (arr.length > 1) {
                    this.$notify.error({
                        title: '操作错误 !',
                        message: '只可选择一条数据后操作 !'
                    })
                    return
                }
                this.drawerForm = JSON.parse(JSON.stringify(arr[0]))
                this.$emit('loadingDbc',this.drawerForm)
                // this.$nextTick(() => {
                //     for(let i=0; i<this.$refs.table.selection.length; i++){
                //         this.$refs.table[i].clearSelection();
                //     }
                // })
                console.log(this.drawerForm)
            },
            // 删除
            async deleteItems() {
                const arr = this.$refs.table.selection;
                if (arr.length === 0) {
                    this.$notify.error({
                        title: '操作错误 !',
                        message: '请选择数据后删除 !'
                    })
                    return
                }
                if (arr.length > 1) {
                    this.$notify.error({
                        title: '操作错误 !',
                        message: '只可选择一条数据删除 !'
                    })
                    return
                }
                try {
                    const ids = []
                    for (const el of arr.values()) {
                        ids.push(el.id)
                    }
                    this.deleteType = true
                    const res = await delDbcFiles({ids})
                    if (res.code === 200) {
                        this.$notify.success({
                            title: '成功提示',
                            message: '数据删除成功'
                        })
                        this.$refs.table.clearSelection();
                        this.deleteType = false
                        this.getDbcList()
                    } else {
                        this.$notify.error({
                            title: '错误提示',
                            message: res.msg
                        })
                        this.deleteType = false
                    }
                } catch (e) {
                    this.deleteType = false
                    console.log(e)
                }
            },
            // 时间选择
            timeChange(e) {
                console.log(e)
                if (e) {
                    this.formInline.startTime = e[0];
                    this.formInline.endTime = e[1];
                } else {
                    this.formInline = {}
                    const data = {
                        pageSize:this.pageSize,
                        pageNo:this.currentPage,
                        fileName: this.formInline.fileName,
                        vehicleType: this.formInline.vehicleType,
                        startTime: this.formInline.startTime,
                        endTime: this.formInline.endTime
                    }
                    getDbcList(data).then(res=>{
                        console.log(res)
                        this.tableData = res.data
                        this.total = res.total
                    }).catch(err=>{
                        console.log(err)
                    })
                }

            },
            // 搜索
            search() {
                const data = {
                    pageSize:this.pageSize,
                    pageNo:this.currentPage,
                    fileName: this.formInline.fileName,
                    vehicleType: this.formInline.vehicleType,
                    startTime: this.formInline.startTime,
                    endTime: this.formInline.endTime
                }
                getDbcList(data).then(res=>{
                    console.log(res)
                    this.tableData = res.data
                    this.total = res.total
                }).catch(err=>{
                    console.log(err)
                })
            },
            rest() {
                this.formInline = {}
                const data = {
                    pageSize:this.pageSize,
                    pageNo:this.currentPage,
                    fileName: this.formInline.fileName,
                    vehicleType: this.formInline.vehicleType,
                    startTime: this.formInline.startTime,
                    endTime: this.formInline.endTime
                }
                getDbcList(data).then(res=>{
                    console.log(res)
                    this.tableData = res.data
                    this.total = res.total
                }).catch(err=>{
                    console.log(err)
                })
            },
            // dbc文件列表
            async getDbcList() {
                const data = {
                    pageSize:this.pageSize,
                    pageNo:this.currentPage,
                    fileName: this.formInline.fileName,
                    startTime: this.formInline.startTime,
                    endTime: this.formInline.endTime
                }
                getDbcList(data).then(res=>{
                    console.log(res)
                    this.tableData = res.data
                    this.total = res.total
                }).catch(err=>{
                    console.log(err)
                })
            },
            // 获取车型列表
            async getDatavehicleTypeList() {
                try {
                    const res = await getDatavehicleTypeList()
                    if (res.code === 200) {
                        this.carOptions = res.data
                    } else {
                        this.$notify.error({
                            title: '错误提示',
                            message: res.msg
                        });
                    }
                } catch (e) {
                    console.log(e)
                }
            },
            // 新增修改弹框
            openDrawer(type) {
                this.dialogType = type
                if (type === 1) {
                    this.drawerTitle = '新增DBC文件'
                    this.drawerForm = {}
                    this.drawerType = true
                } else {
                    const arr = this.$refs.table.selection;
                    if (arr.length === 0) {
                        this.$notify.error({
                            title: '操作错误 !',
                            message: '请选择数据后操作 !'
                        })
                        return
                    }
                    if (arr.length > 1) {
                        this.$notify.error({
                            title: '操作错误 !',
                            message: '只可选择一条数据后操作 !'
                        })
                        return
                    }
                    this.drawerForm = JSON.parse(JSON.stringify(arr[0]))
                    console.log(this.drawerForm)
                    this.drawerTitle = '修改DBC文件'
                    this.drawerType = true
                }
            },
            // 关闭弹框
            drawerClose() {
                this.getDbcList()
                this.$refs.table.clearSelection();
                this.drawerType = false
            },
            getIndex(index) {
                return (this.currentPage - 1) * this.pageSize + index + 1
            },
            handleSizeChange(val) {
                const data = {
                    pageSize:val,
                    pageNo:this.currentPage,
                    fileName: this.formInline.fileName,
                    vehicleType: this.formInline.vehicleType,
                    startTime: this.formInline.startTime,
                    endTime: this.formInline.endTime
                }
                getDbcList(data).then(res=>{
                    console.log(res)
                    this.tableData = res.data
                    this.total = res.total
                }).catch(err=>{
                    console.log(err)
                })
            },
            handleCurrentChange(val) {
                const data = {
                    pageSize:this.pageSize,
                    pageNo:val,
                    fileName: this.formInline.fileName,
                    vehicleType: this.formInline.vehicleType,
                    startTime: this.formInline.startTime,
                    endTime: this.formInline.endTime
                }
                getDbcList(data).then(res=>{
                    console.log(res)
                    this.tableData = res.data
                    this.total = res.total
                }).catch(err=>{
                    console.log(err)
                })
            },
        }
    }
</script>

<style scoped>
    .pagination {
        margin-top: 10px;
        text-align: right;
    }

    .box-card {
        text-align: left;
        border-radius: 10px;
        height: 100%;
    }
</style>
<style scoped lang="scss">
    .tableListValue {
        //滚动条的宽高
        ::-webkit-scrollbar {
            width: 1vh;
            height: 1vh;
        }

        //滚动条的滑块背景色
        ::-webkit-scrollbar-thumb {
            background: #ccc;
            border-radius: 2vh;
        }

        //滚动条的背景色
        ::-webkit-scrollbar-track {
            background: rgba(#ccc, 0.3);
        }

    }


    /* 设置滚动条的样式 */
    /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/

    ::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }


    /*定义滚动条轨道 内阴影+圆角*/

    ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.1);
        border-radius: 4px;
        background-color: #F5F5F5;
    }


    /*定义滑块 内阴影+圆角*/

    ::-webkit-scrollbar-thumb {
        border-radius: 4px;
        -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.1);
        background-color: #ccc;

    }

</style>
